import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import debug from 'debug';
import { Box, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { ClipLoader } from "react-spinners";

import { getAllCapsules, updateCapsuleCount } from '../../actions/capsuleActions';
import Entry from '../../components/entry/Entry';
import styles from './styles';

const output = debug("catalog");

function Catalog() {
    const dispatch = useDispatch();
    const capsules = useSelector(state => state.Capsule.capsuleList);
    const [isAwaitingCapsules, setIsAwaitingCapsules] = useState(true);

    //loads all of the user's capsules into state
    //upon component creation
    useEffect(() => {
        dispatch(getAllCapsules);
        output("capsules: ", capsules);

        //update count
        dispatch(updateCapsuleCount);
    }, [])

    /* disables spinner when server responds */
    useEffect(() => {
        if (capsules) {
            //disable spinner
            setIsAwaitingCapsules(false);
        }

    }, [capsules])

    return (
        <Box className='container'>
            <Box sx={styles.spinnerContainer}>
                <ClipLoader loading={isAwaitingCapsules} color={"black"} css="margin: auto;" />
            </Box>
            {capsules?.length == 0 && (<Typography variant='h5' align='center' >You dont have any Capsules yet. <Link to={"/app/editor"} >Create One</Link> </Typography>)}
            <Box sx={styles.entryContainer}>
                {capsules?.map((item, index) => {
                    return <Entry capsule={item} key={index} />
                })}
            </Box>
        </Box>
    )
}

export default Catalog